import { render, staticRenderFns } from "./Edit2Icon.vue?vue&type=template&id=72811d50&scoped=true&"
import script from "./Edit2Icon.vue?vue&type=script&lang=js&"
export * from "./Edit2Icon.vue?vue&type=script&lang=js&"
import style0 from "./Edit2Icon.vue?vue&type=style&index=0&id=72811d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72811d50",
  null
  
)

export default component.exports